export default "__VITE_ASSET__aclV3l6W__"